import { initGlobalRegistry } from '@api/globalRegistry';
import { Socket, io } from 'socket.io-client';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';
import { Message } from 'protobufjs';

import { queryClient } from '../App';

export class WebSocketManager {
  private ws: Socket | null = null;

  constructor(
    private readonly url: string = import.meta.env.VITE_API_URL ?? 'localhost:8080',
    private readonly secure: boolean = !url.includes('localhost')
  ) {
    window.addEventListener('beforeunload', () => this.cleanup());
    initGlobalRegistry();
  }

  public connect(token: string): Socket | null {
    const base = this.secure ? 'wss' : 'ws';

    this.ws = io(`${base}://${this.url}`, {
      auth: { token },
      transports: ['websocket'],
      parser: Shared.SocketParser,
    });

    this.setupEventHandlers();

    return this.ws;
  }

  private setupEventHandlers() {
    if (!this.ws) return;

    this.ws.on('disconnect', () => {
      this.cleanup();
      useAppStore.setState({ isConnecting: true });

      setTimeout(() => queryClient.resetQueries({ queryKey: ['status'] }), 2000);
    });

    for (const [opcode, _] of Object.entries(Shared.ProtoMessages)) {
      this.ws.on(opcode, (data) => Shared.MessageRegistry.parse(Number(opcode), data));
    }
  }

  public send(message: { Opcode: number } & Message) {
    if (!this.ws || !this.ws.active) return;

    this.ws.emit(message.Opcode.toString(), message);
  }

  private cleanup() {
    this.ws?.disconnect();
  }
}

export const wsManager = new WebSocketManager();

export const sendMessage = (message: { Opcode: number } & Message) => wsManager.send(message);
export const timeDiff = () => 60;